import { Column, Columns, Tile } from '@codeparva/ui-components-library';
import React, { useEffect, useState } from 'react';
import { weakKey } from '../../../../../../utilities/weakKey';
import { HorizontalAndVerticalCardConfig } from '../constants/horizontalAndVerticalCardConfig';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import {
  GenericCTAButtonComponentHelper,
  ViewRatesAmenitiesCTA,
} from './CTAButtonHelper';
import { ModalHelper } from './modalHelper';
import { desktopscreensize } from '../../../../../../utilities/constants';
import { useWindowDimensions } from '../../../../../../utilities/Dimensions';
import { GetAlertText, getAmenitiesList } from './AmenitiesHelper';
import { addZeroesAndGetWebRate } from './rateHelper';
import { VerticalCardsComponent } from './VerticalCards';
import { CPImage } from '../../../../../../components/imageWrapper/CPImage';

const HorizontalCards = ({
  data,
  UnitAvailabilityConfig,
  onSetIndividualData,
  WhatWeOfferConfig,
  index,
  transformedGatsbyImageData,
  facilityIdDetails,
}: UnitAvailabilityTypes.TUnitAvailabilityRes) => {
  const unitTypeName = data.unitTypeName;
  const {
    unitTypeRate: { Month },
    unitTypeCategory,
    tfw,
    unitdimensions,
    customArt,
  } = data;
  const { reservation: { is_enabled = false } = {} } = tfw;
  const { width } = useWindowDimensions();
  const [showModal, onShowModal] = useState(false);
  const [viewCTAStatus, setViewCTAStatus] = useState(false);
  const [isModalClicked, setIsModalClicked] = useState(false);
  const showModalImg = () => {
    onShowModal(!showModal);
    setIsModalClicked(true);
  };
  useEffect(() => {
    if (showModal) {
      const scrollY = window.scrollY;
      document.body.style.overflowY = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
    } else if (!showModal) {
      const scrollY = document.body.style.top;
      document.body.style.overflowY = '';
      document.body.style.position = '';
      document.body.style.top = '';
      isModalClicked && window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }, [showModal]);

  const classNameSelector = () => {
    return 'is-flex is-justify-content-left is-align-items-left';
  };
  if (data) {
    const {
      vacantUnitsCount: { total_count },
    } = data;
    const getDescription = () => {
      if (tfw && tfw.description && unitdimensions) {
        const { description } = tfw;
        const { width, depth } = unitdimensions;
        return description
          ? description
          : data.aliasName
          ? data.aliasName
          : `${width}' X ${depth}' ${unitTypeCategory}`;
      } else {
        return unitTypeName;
      }
    };
    return (
      <>
        {width > desktopscreensize && (
          <Columns
            marginless
            className={`horizontalCardsColumns cp-section-bg-unit-light`}
          >
            <ModalHelper
              showModal={showModal}
              data={data}
              unitTypeName={unitTypeName}
              showModalImg={showModalImg}
              transformedGatsbyImageData={transformedGatsbyImageData}
            />
            <Column>
              <Tile
                kind="ancestor"
                className={`${
                  viewCTAStatus ? 'AncestorTileActive p-0' : 'AncestorTile p-0'
                }`}
              >
                <Tile kind="parent" className="ParentTile">
                  <Tile
                    kind="child"
                    className={`ChildTileOne ${classNameSelector()}`}
                  >
                    <div
                      className="is-flex is-justify-content-left is-align-items-center"
                      onClick={
                        customArt && customArt.show === undefined
                          ? showModalImg
                          : undefined
                      }
                    >
                      <CPImage
                        gatsbyImageData={transformedGatsbyImageData}
                        className="tile-image thumbNailImage"
                      />
                    </div>
                  </Tile>
                  <Tile
                    kind="child"
                    className={`ChildTileFour is-flex-grow-2 ${classNameSelector()}`}
                  >
                    <div className="amenitiesDivUnitType has-text-left">
                      <h4 className="has-text-text-color-text">
                        {getDescription()}
                      </h4>
                      <span className="alertTextspan subtitle1">
                        <GetAlertText
                          totalCount={total_count}
                          isReservationOrMoveInEnabled={is_enabled}
                        />
                      </span>
                    </div>
                    <div className="amenitiesDiv has-text-left is-flex is-flex-wrap-wrap">
                      {WhatWeOfferConfig &&
                        getAmenitiesList(
                          data,
                          WhatWeOfferConfig,
                          viewCTAStatus
                        )}
                    </div>
                    {data.amenitiesList.length > 6 && (
                      <ViewRatesAmenitiesCTA
                        index={index}
                        viewCTAStatus={viewCTAStatus}
                        setViewCTAStatus={setViewCTAStatus}
                      />
                    )}
                  </Tile>
                  <Tile
                    kind="child"
                    className={`ChildTileFive is-flex is-justify-content-center is-align-items-center`}
                  >
                    <div className="has-text-left pb-3 priceDiv">
                      <h4 className="has-text-text-color-text">
                        {HorizontalAndVerticalCardConfig.currencyCodes[
                          data.currencyCode
                        ] || '$ '}
                        {addZeroesAndGetWebRate(tfw, Month)}
                        {HorizontalAndVerticalCardConfig.perMonth}
                      </h4>
                    </div>
                    <GenericCTAButtonComponentHelper
                      UnitAvailabilityConfig={UnitAvailabilityConfig}
                      data={data}
                      onSetIndividualData={onSetIndividualData}
                      facilityIdDetails={facilityIdDetails}
                    />
                  </Tile>
                </Tile>
              </Tile>
            </Column>
          </Columns>
        )}
        {width <= desktopscreensize && (
          <VerticalCardsComponent
            data={data}
            UnitAvailabilityConfig={UnitAvailabilityConfig}
            key={weakKey(data)}
            theme="dark"
            onSetIndividualData={onSetIndividualData}
            WhatWeOfferConfig={WhatWeOfferConfig}
            index={index}
            transformedGatsbyImageData={transformedGatsbyImageData}
            facilityIdDetails={facilityIdDetails}
          />
        )}
      </>
    );
  }
  return <></>;
};
export default HorizontalCards;
